module.exports = __webpack_public_path__ + "img/services.44db3b39.webp";